import React, {useEffect} from 'react';
import PropTypes from 'prop-types';
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";
import ModalTextContent from './ModalTextContent';
import ModalNavigation from './ModalNavigation';
import CollectionItemModalGallery from './CollectionItemModalGallery';
import useModalFocusManagement from '../hooks/useModalFocusManagement';
import updateUrl from '../actions/updateUrl';

const CollectionModal = ({setModalIsOpen, modalContent, setModalContent, currentModalItemIndex, setCurrentModalItemIndex, modalContentLength, language, setWindowLocationHash, setItemId}) => {

	const placeholderImgSrc = `${mainScript.assetPath}images/png/placeholder/bmo-portrait-placeholder.png`;
	const textAlignment = modalContent.gallery.length > 0 ? '' : 'start';
	const {modalRef, closeButtonRef} = useModalFocusManagement({focusCloseButtonOn: [modalContent.id]});

	const focusRelatedCardButton = (attempt = 0) => {
		const selector = `.single-collection-page__card-button[aria-controls="modal-${modalContent.id}"]`;
		const relatedCardButton = document.querySelector(selector);

		if (relatedCardButton) {
			relatedCardButton.focus();
			return;
		}

		if (attempt < 4) {
			window.requestAnimationFrame(() => focusRelatedCardButton(attempt + 1));
		}
	};

	const handleCloseClick = () => {
		setModalIsOpen(false);
		setCurrentModalItemIndex(null);
		if (setWindowLocationHash) setWindowLocationHash(null);
		if (setItemId) setItemId(null);
		window.requestAnimationFrame(() => focusRelatedCardButton());
	};

	useEffect(() => {
		updateUrl(modalContent.id);
	}, [modalContent.id]);

	
	return (
		<div ref={modalRef} id={`modal-${modalContent.id}`} className='modal' role='dialog' aria-modal='true' aria-label={modalContent.title}>
			<button ref={closeButtonRef} className='modal__close-btn' aria-label='close' onClick={handleCloseClick}></button>
			<div className={`modal__main-content align-items--${textAlignment}`}>
				<TransformWrapper>
					{({ zoomIn, zoomOut, resetTransform }) => (
						<div className='modal__image-container'>
							<div className="zoom-controls">
								<button aria-label="Zoom in" className='zoom-controls__btn button' onClick={() => zoomIn()}>+</button>
								<button aria-label="Zoom out" className='zoom-controls__btn button' onClick={() => zoomOut()}>-</button>
								<button aria-label="Reset zoom" className='zoom-controls__btn button reset' onClick={() => resetTransform()}/>
							</div>
							<TransformComponent>
								<div className='aspect-ratio-box'>
									<img src={modalContent.image.url ? modalContent.image.url : placeholderImgSrc} alt={modalContent.title}/>
								</div>
							</TransformComponent>
						</div>
					)}
				</TransformWrapper>
				<div className='modal__info'>
					<ModalTextContent
						title={modalContent.title}
						subtitle={modalContent.subtitle}
						text={modalContent.content}
					/>
					<CollectionItemModalGallery
						mainImgSrc={modalContent.image.url}
						setModalContent={setModalContent}
						currentModalItemIndex={currentModalItemIndex}
						gallery={modalContent.gallery}
					/>
				</div>
			</div>
			<ModalNavigation 
				currentModalItemIndex={currentModalItemIndex}
				modalContentLength={modalContentLength}
				language={language}
				setCurrentModalItemIndex={setCurrentModalItemIndex}
			/>
		</div>
	)
}

export default CollectionModal;

CollectionModal.propTypes = {
	modalContent: PropTypes.object,
	setModalIsOpen: PropTypes.func,
	setCurrentModalItemIndex: PropTypes.func,
	modalContentLength: PropTypes.number,
	currentModalItemIndex: PropTypes.number,
	setModalContent: PropTypes.func,
	language: PropTypes.string,
	setWindowLocationHash: PropTypes.func,
	setItemId: PropTypes.func,
}